import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { TimeReportingFormTypes } from "models/formTypes";
import { FormHandles, TextAreaExtraProps } from "models/propTypes/genericFormProps";
import { CommentsFormViewProps } from "models/propTypes/timeReportingPropTypes";
import { TranslationKeys } from "translations";
import { DateConstants, IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModelTimeReporting } from "wint-api-client/dist/types";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const CommentsForm: ForwardRefRenderFunction<FormHandles, CommentsFormViewProps> = (props, ref) => {
  const { tableHeaderValues, row, currentWeekDateRange, isCommentDisabled } = props;

  const getCommentFields = (commentType: WintSuperkollAPIModelTimeReporting.ProjectTimeCommentType) => {
    const fields = {};
    DateConstants.FullWeekStartWithMonday.forEach((day, index) => {
      const date = DateHelper.addDays(currentWeekDateRange?.start ?? new Date(), index);
      const month = LocalizationHelperInstance.getFormattedDate(date, DateConstants.MonthShortConfig);

      (fields as any)[
        `${
          commentType === WintSuperkollAPIModelTimeReporting.ProjectTimeCommentType.External ? "external" : "internal"
        }${day}`
      ] = {
        label:
          commentType === WintSuperkollAPIModelTimeReporting.ProjectTimeCommentType.External
            ? TranslationKeys.TimeReporting.ExternalComment
            : TranslationKeys.TimeReporting.InternalComment,
        controlLabel: `${LocalizationHelperInstance.getFormattedMessage(
          `TimeReporting.WeekDayLongFromMonday_${index}`
        )}. ${(tableHeaderValues as any)[day]} ${month}, ${(row as any)[day] ?? 0} h`,
        type: FormEnums.FormFieldType.TEXTAREA,
        icon: IconDefinitionConstants.WCommentDots,
        disabled: isCommentDisabled?.bind(null, commentType, day, row),
        maxLength: 500,
        extraProps: {
          rows: 2,
        } as TextAreaExtraProps,
      };
    });
    return fields;
  };

  return (
    <GenericForm<TimeReportingFormTypes.WeekComments>
      formRef={ref}
      {...props}
      fields={[
        {
          label: TranslationKeys.TimeReporting.External,
          type: FormEnums.FormSectionType.SIMPLETAB,
          innerFields: getCommentFields(WintSuperkollAPIModelTimeReporting.ProjectTimeCommentType.External),
        },
        {
          label: TranslationKeys.TimeReporting.Internal,
          type: FormEnums.FormSectionType.SIMPLETAB,
          innerFields: getCommentFields(WintSuperkollAPIModelTimeReporting.ProjectTimeCommentType.Internal),
        },
      ]}
      enableControlLables
      formGridLayout={{ message: false }}
      hideOptionalIndicator
    />
  );
};

export default forwardRef(CommentsForm);
